import { IRequesterInfo, KeyValuePair } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IChatDealerBreakdown } from '../models'

export class GetDealerBreakdownApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo, dealerSapCode: string) {
    super({
      url: `admin/chatbot-analytics/dealer-usage/${encodeURIComponent(dealerSapCode)}/breakdown`,
      requesterInfo,
    })
  }

  public async getBreakdown(fromUtc: Date, toUtc: Date): Promise<IChatDealerBreakdown> {
    const query = new KeyValuePair<string>()
    query.add('fromUtc', fromUtc.toISOString())
    query.add('toUtc', toUtc.toISOString())
    this.queryParams = query
    return await this.getAsync<IChatDealerBreakdown>()
  }
}
